import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import endOfLifeIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getEndOfLife42Totals } from "../../../../../apis/Product/EndOfLifeFlow42Api";

const EndOfLife42Icon = () => (
  <img src={endOfLifeIcon} alt="End of Life Icon" width={76} height={76} />
);

const EndOfLife42Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  refreshTrigger,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalEndOfLifeItem, setTotalEndOfLifeItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getEndOfLife42Totals({
        productId,
        setTotals: setTotalEndOfLifeItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals, refreshTrigger]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener('refresh-end-of-life-42-totals', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-end-of-life-42-totals', handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`end-of-life-42-category ${className || ""}`}
      leftBoxProps={{
        icon: <EndOfLife42Icon />,
        title: t("END_OF_LIFE_STAGE") || "End of Life Stage (EoL)",
        description:
          t("END_OF_LIFE_STAGE_DESC") ||
          "Describes what happens to the product once it is no longer used — from removal to final disposal. It covers taking it down, moving it, processing it for recycling or reuse, and managing what cannot be recovered.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_42") || "Total for Flow 42",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalEndOfLifeItem?.impact_totals || null,
        lastUpdated: totalEndOfLifeItem?.updated_at
          ? formatDate(totalEndOfLifeItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default EndOfLife42Header;

